import * as types from './actionTypes';

export function savingNodesPositions(data) {
  return dispatch => {
    dispatch({ type: types.SCROLLING_REFERENCE, payload: data });
  };
}



// WEBPACK FOOTER //
// ./src/actions/scrolling.js